"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteOtaGroupPayload = exports.UpdateOtaGroupPayload = exports.CreateOtaGroupPayload = exports.OtaGroupItem = exports.OtaGroupList = exports.OtaGroup = void 0;
const effect_1 = require("effect");
const NAMESPACE = 'Culligan.Api.V1.Admin.Device.Schema';
exports.OtaGroup = effect_1.Schema.Struct({
    id: effect_1.Schema.NonEmptyString,
    name: effect_1.Schema.NonEmptyString,
    model: effect_1.Schema.propertySignature(effect_1.Schema.String).annotations({
        description: 'Model code of the first device in the group.',
    }),
    serialNumbers: effect_1.Schema.Array(effect_1.Schema.NonEmptyString),
}).annotations({
    identifier: `${NAMESPACE}.OtaGroup`,
});
exports.OtaGroupList = effect_1.Schema.Struct({ items: effect_1.Schema.Array(exports.OtaGroup) }).annotations({
    identifier: `${NAMESPACE}.OtaGroupList`,
});
exports.OtaGroupItem = effect_1.Schema.Struct({ item: exports.OtaGroup }).annotations({
    identifier: `${NAMESPACE}.OtaGroupItem`,
});
exports.CreateOtaGroupPayload = effect_1.Schema.Struct({
    name: effect_1.Schema.NonEmptyString,
    serialNumbers: effect_1.Schema.NonEmptyArray(effect_1.Schema.NonEmptyString),
}).annotations({
    identifier: `${NAMESPACE}.CreateOtaGroupPayload`,
});
exports.UpdateOtaGroupPayload = effect_1.Schema.Struct({
    id: effect_1.Schema.NonEmptyString,
    name: effect_1.Schema.NonEmptyString,
    serialNumbers: effect_1.Schema.NonEmptyArray(effect_1.Schema.NonEmptyString),
}).annotations({
    identifier: `${NAMESPACE}.UpdateOtaGroupPayload`,
    description: 'Full replacement. Name uniqueness is not re-checked, and createdBy is overwritten with the caller.',
});
exports.DeleteOtaGroupPayload = effect_1.Schema.Struct({
    id: effect_1.Schema.optionalWith(effect_1.Schema.NonEmptyString, { exact: true }),
}).annotations({
    identifier: `${NAMESPACE}.DeleteOtaGroupPayload`,
});
//# sourceMappingURL=schema.js.map